import actionTypes from 'redux/actions/actionTypes'

const actions = {
	configFetched: config => ({
		type: actionTypes.FILL_IN_THE_BLANKS_SESSION_CONFIG_FETCHED,
		config,
	}),
	configFailed: error => ({
		type: actionTypes.FILL_IN_THE_BLANKS_SESSION_CONFIG_FAILED,
		error,
	}),
	studentDataFetched: students => ({
		type: actionTypes.FILL_IN_THE_BLANKS_SESSION_STUDENT_DATA_FETCHED,
		students,
	}),
}

export default actions
